import { GroupBase } from "react-select";
import AsyncSelect, { AsyncProps } from "react-select/async";

import {
  buildCustomDropdownComponents,
  CustomDropdownProps,
  useGetDropdownStyles
} from "../Dropdown";

export type Props<
  Option,
  IsMulti extends boolean,
  Group extends GroupBase<Option>
> = AsyncProps<Option, IsMulti, Group> & CustomDropdownProps;

export default function AsyncDropdown<
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>
>(props: Props<Option, IsMulti, Group>) {
  const {
    dataNoTranslate,
    styles: ignoreStyles,
    size = "small",
    error = false,
    menuWidth,
    children,
    ...otherProps
  } = props;

  const styles = useGetDropdownStyles<Option, IsMulti, Group>({
    size,
    error,
    menuWidth
  });

  const customComponents = buildCustomDropdownComponents<
    Option,
    IsMulti,
    Group
  >({
    dataNoTranslate,
    children
  });

  return (
    <AsyncSelect
      components={customComponents}
      styles={styles}
      {...otherProps}
    />
  );
}
